module.exports = {"id":"201455","name":"Geoffrey Kondogbia","rating":"80","photo":"./data/images/photos/4/201455.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GeoffreyKondogbia0.json
// module id = 1553
// module chunks = 0